import gql from 'graphql-tag';

const DEALERSHIP_CLAIM_FRAGMENT = gql`
  fragment DealershipClaimFragment on DealershipClaim {
    dealer_id
    dealer_name
  }
`;

export default DEALERSHIP_CLAIM_FRAGMENT;
